import { useSelector } from 'react-redux';
import AppLayout from '../components/global/layout/AppLayout.jsx';
import { Navigate } from 'react-router-dom';
import AuthLayout from '../components/global/layout/AuthLayout.jsx';
import MobileLayout from '../MobileView/MobileLayout.jsx';

const ProtectedRoute = ({ type, children, title, image, isMobile = false }) => {
    const { loggedIn } = useSelector(state => state.user);
    if (type === "private") {
        return loggedIn ? (
            isMobile ? <MobileLayout>{children}</MobileLayout> : <AppLayout title={title}>{children}</AppLayout>
        ) : (
            <Navigate to="/" replace />
        );
    }

    // if (type === "mobile") {
    //     return loggedIn ? (
    //         <AppLayout title={title}>{children}</AppLayout>
    //     ) : (
    //         <Navigate to="/" replace />
    //     );
    // }

    if (type === "public") {
        return children;
    }

    if (type === "auth") {
        return !loggedIn ? (
            <AuthLayout image={image} title={title}>
                {children}
            </AuthLayout>
        ) : (
            isMobile ? <Navigate to="/quote" replace /> : <Navigate to="/dashboard" replace />
        );
    }

    return null;
};

export default ProtectedRoute;
